import { render, staticRenderFns } from "./AlgoliaGoogleTypeaheadSF.vue?vue&type=template&id=35a00138"
import script from "./AlgoliaGoogleTypeaheadSF.vue?vue&type=script&lang=js"
export * from "./AlgoliaGoogleTypeaheadSF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports